<template>
  <a
    :title="title || actionTitle"
    :href="href"
    :class="['table-row-action', actionClass]"
    :data-confirm="confirmMessage"
    :data-method="dataMethod"
    @click="clickActionCall"
  >
  </a>
</template>

<script>
export default {
  props: {
    title: String,
    confirm: String,
    href: {
      type: String,
      default: "#"
    },
    action: {
      type: String,
      required: true,
      validator: function (value) {
        return [
          "read",
          "update",
          "delete",
          "upload",
          "approve",
          "import",
          "download",
          "remove",
          "block",
          "unblock",
          "show",
          "hide",
          "revoke"
        ].indexOf(value) !== -1
      }
    },
    graphqlAction: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    actionClass: function () {
      return "action-" + this.action
    },

    confirmMessage: function () {
      if (this.href != "#" && this.isLinkAction("delete", "remove", "block", "unblock", "revoke", "approve")) {
        return this.confirm && this.confirm.length > 0 ? this.confirm : "Are you sure?"
      }
    },

    dataMethod: function () {
      // For link actions, we use data-method to trigger Rails UJS handlers for delete/block/unblock actions
      if (this.isLinkAction("delete", "block")) {
        return "delete"
      } else if (this.isLinkAction("unblock")) {
        return "put"
      }
    },

    actionTitle: function () {
      return {
        read: "Details",
        update: "Edit",
        delete: "Remove",
        remove: "Remove",
        block: "Block",
        unblock: "Unblock",
        approve: "Approve",
        revoke: "Revoke"
      }[this.action]
    }
  },

  methods: {
    isLinkAction: function (...actions) {
      return !this.graphqlAction && actions.includes(this.action)
    },

    clickActionCall: function (event) {
      if (this.href == "#") {
        event.preventDefault();

        let approve = true;

        if (this.isLinkAction("delete", "remove", "block", "unblock", "revoke", "approve") || (this.confirm && this.confirm.length > 0)) {
          approve = window.confirm(this.confirm && this.confirm.length > 0 ? this.confirm : "Are you sure?");
        }

        if (approve == true) {
					this.$emit("clickAction", event);
				}
      }
    }
  }
}
</script>
